import { createAxiosWithCache } from '../utils';
import type { Translations } from '~/models';

const axiosWithCache = createAxiosWithCache({ maxAge: 15 });

export const translationsProvider = async (
  baseUrl: string,
  keys: Record<string, string>,
): Promise<Translations | undefined> => {
  const url = new URL('/system/ajax/Localization/Translate', baseUrl);
  const values = Object.values(keys);

  if (values.length > 0) {
    values.forEach((key: string) => {
      url.searchParams.append('keys', key);
    });
  }

  try {
    const { data } = await axiosWithCache.get<Translations>(url.toString());

    return data;
  } catch (error) {
    // eslint-disable-next-line no-console -- Log error to console.
    console.error(error);
  }

  return undefined;
};
